import "./tutorialLayerComponent.scss";
import {useLangContext} from "../../../../shared/features/Language";

interface IProps {
  onClick?: () => void;
}

export const TutorialLayerComponent = ({onClick}:IProps) => {
  const {textData} = useLangContext();

  return (
    <div className="assembly-tutorial" onClick={onClick}>
      <div className="assembly-view_grid">
        <div className="assembly-view_base tutorial-area">
          <div className="tutorial-note">{textData.mobileTutorialBlock1}</div>
          <div className="tutorial-line"></div>
        </div>
        <div className="assembly-view_area tutorial-area">
          <div className="tutorial-note">{textData.mobileTutorialBlock4}</div>
          <div className="tutorial-line"></div>
        </div>
        <div className="assembly-view_main">
          <div className="assembly-main-field">
            <div className="single-brick tutorial-area">
              <div className="tutorial-note">{textData.mobileTutorialBlock3}</div>
              <div className="tutorial-line"></div>
            </div>
          </div>
        </div>
        <div className="assembly-view_preview">
          <div className="assembly-preview tutorial-area">
            <div className="tutorial-note">{textData.mobileTutorialBlock2}</div>
            <div className="tutorial-line"></div>
          </div>
        </div>
        <div className="assembly-view_footer"></div>
      </div>
    </div>
  );
}
